import { render, staticRenderFns } from "./InputAlertRuleDeploymentVariable.global.vue?vue&type=template&id=07ccf9d2&lang=pug&"
import script from "./InputAlertRuleDeploymentVariable.global.vue?vue&type=script&lang=ts&"
export * from "./InputAlertRuleDeploymentVariable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports